import React from 'react';
import {
  DeviceLike,
  formatDeviceLabel,
  getDeviceIdentityLines,
} from '../../utils/deviceDisplay';

/** Table cell: hostname + logged-on user (never bare UUID when name exists). */
export function DeviceIdentityCell({
  device,
  fallbackId,
  compact = false,
  className = '',
}: {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  device?: any;
  fallbackId?: string;
  /** Single line "host · user" instead of two lines */
  compact?: boolean;
  className?: string;
}) {
  const d = device as DeviceLike | undefined;
  if (compact) {
    return <span className={className}>{formatDeviceLabel(d, fallbackId)}</span>;
  }
  const { primary, secondary } = getDeviceIdentityLines(d, fallbackId);
  return (
    <div className={className}>
      <div className="font-medium text-slate-800 leading-tight">{primary}</div>
      {secondary ? (
        <div className="text-xs text-slate-500 leading-tight mt-0.5">{secondary}</div>
      ) : null}
    </div>
  );
}

export default DeviceIdentityCell;
